import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { closeSnackbar } from '../actions/Notification'

import Snackbar from '@material-ui/core/Snackbar'

class Notifications extends React.PureComponent {
  render () {
    return <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      autoHideDuration={2500}
      open={this.props.snackbar.open}
      onClose={this.props.actions.closeSnackbar}
      ContentProps={{
        'aria-describedby': 'message-id'
      }}
      message={<span id="message-id">{this.props.snackbar.message}</span>}
    />
  }
}

export default connect(({notifications}) => notifications, dispatch => ({
  actions: bindActionCreators({
    closeSnackbar
  }, dispatch)
}))(Notifications)


// WEBPACK FOOTER //
// ./containers/Notifications.js